// Props paths which are resolved as nunjucks expressions by processDynamicProps processor
export const NUNJUCKS_PREPROCESS_PROPS = [
  'label',
  'value',
  'title',
  'href',
  'tooltip',
  'icon.value',
  'icon.tooltip',
] as const;

// Props paths which are resolved as nunjucks expressions lazily during rendering of the actual custom view components
export const NUNJUCKS_LAZY_PROCESSED_PROPS = ['showWhen.value'] as const;

export const NUNJUCKS_PROPS = [
  ...NUNJUCKS_PREPROCESS_PROPS,
  ...NUNJUCKS_LAZY_PROCESSED_PROPS,
];
